import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import TransformComponent from '../../../Component/Transform';
import Point from '../../../Utility/Point';
import ElementComponent from '../../../Component/UI/Element';
import { delay } from '../../../Utility/Task/TaskQueue';

export class PulseLoop extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: {
            duration: number;
            scale1: Point;
            scale2: Point;
            initialDelay?: number;
            delay?: number;
            interval?: number;
            text?: GameObject;
        }
    ): IterableIterator<number> {
        meta.interval = meta.interval || 3;
        const transform = gameObject.getComponent(TransformComponent);

        let scaleTween;
        if (transform) {
            transform.scale.set(meta.scale1.x, meta.scale1.y);
            scaleTween = this.getTween(transform.scale);
        } else {
            const transformElement = gameObject.getComponent(ElementComponent);
            transformElement.scale.set(meta.scale1.x, meta.scale1.y);
            scaleTween = this.getTween(transformElement.scale);
        }
        // Loop.
        yield* delay(meta.initialDelay || 0);
        while (true) {
            let i = 0;
            while (i < meta.interval) {
                i++;
                scaleTween
                    .to({ x: meta.scale2.x, y: meta.scale2.y }, meta.duration)
                    .easing(Easing.Quadratic.InOut);
                if(meta.text) {
                    this.getTween(meta.text).to({ alpha: 1 }, meta.duration)
                        .easing(Easing.Quadratic.InOut).start(this.elapsedTime);
                }
                yield* this.startTween(scaleTween);
                scaleTween
                    .to({ x: meta.scale1.x, y: meta.scale1.y }, meta.duration)
                    .easing(Easing.Quadratic.InOut);
                if(meta.text) {
                    this.getTween(meta.text).to({ alpha: 0 }, meta.duration)
                        .easing(Easing.Quadratic.InOut).start(this.elapsedTime);
                }
                yield* this.startTween(scaleTween);
            }
            scaleTween
                .to(
                    {
                        x: (meta.scale1.x + meta.scale2.x) / 2,
                        y: (meta.scale1.y + meta.scale2.y) / 2,
                    },
                    meta.duration
                )
                .easing(Easing.Quadratic.InOut);
            yield* this.startTween(scaleTween);
            yield* delay(meta.delay || 0);
        }
    }
}
